import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { defineAsyncComponent, defineComponent, ref, watch } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { useClickOutside, useFocusEvents } from '@/shared/lib';
import VFadeTransition from '@/shared/ui/transitions/VFadeTransition.vue';
import { useAuthStore } from '@/store/authStore';
import { useNotificationsStore } from '@/store/notifications';
import NotificationsButton from './NotificationsButton.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderNotificationsButton',
  props: {
    headerHeight: {
      default: 0
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'HeaderNotificationsButton'
    });
    var NotificationsContent = defineAsyncComponent(function () {
      return import('@/features/notifications/ui/NotificationsContent.vue');
    });
    var ModalNotifications = defineAsyncComponent(function () {
      return import('@/features/notifications/ui/ModalNotifications.vue');
    });
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      hasUnreadNotifications = _storeToRefs.hasUnreadNotifications;
    var screen = useScreenPlugin();
    var notificationsOpen = ref(false);
    var notificationsModalOpen = ref(false);
    var rootRef = ref(null);
    var _useNotificationsStor = useNotificationsStore(),
      resetFilters = _useNotificationsStor.resetFilters;
    var toggleNotifications = function toggleNotifications() {
      if (screen.isMobileOrTablet) {
        notificationsModalOpen.value = !notificationsModalOpen.value;
      } else {
        notificationsOpen.value = !notificationsOpen.value;
      }
      if (notificationsOpen.value) {
        resetFilters();
      }
    };
    var closeNotifications = function closeNotifications() {
      if (screen.isMobileOrTablet) {
        notificationsModalOpen.value = false;
      } else {
        notificationsOpen.value = false;
      }
      resetFilters();
    };
    useClickOutside(rootRef, function (event) {
      if (screen.isDesktop) {
        // Клик по селекту закрывает всплывающее окно
        // поэтому нужно проверить, не кликнули ли мы по селекту
        var target = event.target;
        var isSelectDropdown = target.closest('.s-options') || target.closest('.s-select__options') || target.closest('.s-option-container');
        if (!isSelectDropdown) {
          notificationsOpen.value = false;
          resetFilters();
        }
      }
    });
    useFocusEvents(rootRef, {
      onFocusOutside: function onFocusOutside(event) {
        if (screen.isDesktop) {
          // та же логика, что и в useClickOutside
          var target = event.target;
          var isSelectDropdown = (target === null || target === void 0 ? void 0 : target.closest('.s-options')) || (target === null || target === void 0 ? void 0 : target.closest('.s-select__options')) || (target === null || target === void 0 ? void 0 : target.closest('.s-option-container'));
          if (!isSelectDropdown) {
            notificationsOpen.value = false;
            resetFilters();
          }
        }
      }
    });
    watch(function () {
      return screen.isMobileOrTablet;
    }, function (newIsMobileOrTablet, oldIsMobileOrTablet) {
      if (newIsMobileOrTablet === oldIsMobileOrTablet) {
        return;
      }
      // Переход на мобильный/планшетный режим
      if (newIsMobileOrTablet && notificationsOpen.value) {
        notificationsOpen.value = false;
        notificationsModalOpen.value = true;
        return;
      }
      // Переход на десктопный режим
      if (!newIsMobileOrTablet && notificationsModalOpen.value) {
        notificationsModalOpen.value = false;
        notificationsOpen.value = true;
      }
    }, {
      immediate: false
    });
    return {
      __sfc: true,
      props: props,
      NotificationsContent: NotificationsContent,
      ModalNotifications: ModalNotifications,
      authStore: authStore,
      hasUnreadNotifications: hasUnreadNotifications,
      screen: screen,
      notificationsOpen: notificationsOpen,
      notificationsModalOpen: notificationsModalOpen,
      rootRef: rootRef,
      resetFilters: resetFilters,
      toggleNotifications: toggleNotifications,
      closeNotifications: closeNotifications,
      VFadeTransition: VFadeTransition,
      NotificationsButton: NotificationsButton
    };
  }
});